import { ROUTE } from "../../routes";
import { StoreKey, partnerApi } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { decryptRes, isFromAndroidWebview } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const navigateToCustomerScreen = async (action, _datastore, { navigate, navigateToBase, instrumentTrack, setDatastore, asyncStorage, network }) => {
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const filterObj = action?.payload?.filterObj || {};
    const numberOfFilterApplied = action?.payload?.numberOfFilterApplied || 0;
    const currentPageCustomer = action?.payload?.currentPageCustomer;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const pageNumber = currentPageCustomer || 1;
    let dynamicLink = 'partnerdashboard/all';
    if (currentActiveTabIndex !== undefined) {
        if (currentActiveTabIndex === 1) {
            dynamicLink = 'partnerdashboard/interestDue';
        }
        else if (currentActiveTabIndex === 2) {
            dynamicLink = 'partnerdashboard/renewal';
        }
        else if (currentActiveTabIndex === 3) {
            dynamicLink = 'partnerdashboard/shortfall';
        }
        else
            dynamicLink = 'partnerdashboard/all';
    }
    const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/${dynamicLink}/${pageNumber}`, filterObj, {
        headers: await getAppHeader(),
    }, async () => { return; }, { isPartnerPlatform: true });
    if (response.status === 200) {
        await navigateToBase(ROUTE.PARTNER_ACTIVE_CUSTOMER, {
            currentPageCutomerFiltered: response?.data?.currentPage,
            pageSizeCustomerFiltered: response?.data?.actualpageSize,
            actualPageSizeCustomerFiltered: response?.data?.actualpageSize,
            customerDataFiltered: response?.data?.data,
            dataFetched: true,
            currentActiveTabIndex: currentActiveTabIndex,
            dataFiltered: true,
            showDashboardCard: false,
            totalPagesFiltered: response?.data?.totalPages,
            numberOfFilterApplied,
            filterObj,
        });
    }
};
export const DownloadSoaData = async (action, _datastore, { navigate, instrumentTrack, setDatastore, asyncStorage, network }) => {
    await setDatastore(ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN, 'customerViewDetail', {
        soaLoading: true
    });
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
    const creditId = action?.payload?.creditId;
    const customerName = action?.payload?.customerViewData?.fullName;
    const partnerName = _user?.linkedPartnerAccounts[0]?.partnerName.replace(/ /g, "_");
    let headers = await getAppHeader();
    // headers.Encryption= 'false'
    const extension = 'pdf';
    fetch(`${partnerApi.getDownloadSoaContent}${creditId}`, { headers: headers })
        .then(async function (response) {
        const res = decryptRes(await response.text());
        await setDatastore(ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN, 'customerViewDetail', {
            soaLoading: false
        });
        return res;
    })
        .then(function (text) {
        fetch(text)
            .then((response) => response.blob())
            .then((blob) => {
            if (isFromAndroidWebview()) {
                window.open(text);
            }
            else {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = url;
                a.download = `${customerName}_soa_data.${extension}`;
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
            .catch((error) => {
            console.warn('Error download file: ', error);
        });
    })
        .catch(function (error) {
        console.log('Request failed', error);
    });
};
export const DownloadHoldingData = async (action, _datastore, { navigate, instrumentTrack, setDatastore, asyncStorage, network }) => {
    await setDatastore(ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN, 'customerViewDetail', {
        holdingLoading: true
    });
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
    const creditId = action?.payload?.creditId;
    const customerName = action?.payload?.customerViewData?.fullName;
    const partnerName = _user?.linkedPartnerAccounts[0]?.partnerName.replace(/ /g, "_");
    let headers = await getAppHeader();
    // headers.Encryption= 'false'
    const extension = 'pdf';
    fetch(`${partnerApi.getDownloadHoldingContent}${creditId}`, { headers: headers })
        .then(async function (response) {
        const res = decryptRes(await response.text());
        await setDatastore(ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN, 'customerViewDetail', {
            holdingLoading: false
        });
        return res;
    })
        .then(function (text) {
        fetch(text)
            .then((response) => response.blob())
            .then((blob) => {
            if (isFromAndroidWebview()) {
                window.open(text, '_parent');
            }
            else {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = url;
                a.download = `${customerName}_holding_data.${extension}`;
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
            .catch((error) => {
            console.warn('Error download file: ', error);
        });
    })
        .catch(function (error) {
        console.log('Request failed', error);
    });
};
export const navigateCustomerJourney = async (action, _datastore, standardUtilities) => {
    const borrowerAccountId = action?.payload?.borrowerAccountId;
    const name = action?.payload?.name;
    AsyncStorage.setItem("pljName", name);
    await standardUtilities.asyncStorage.set(StoreKey.PLJ_borrowerAccountId, borrowerAccountId);
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId });
};
